export const fieldsEn = {
  amount: 'Amount',
  contract: 'Contract',
  currency: 'Currency',
  dateFrom: 'Period from',
  dateTo: 'Period to',
  from: 'From',
  paymentIndicator: 'Payment type',
  paymentMethod: 'Payment method',
  paymentStatus: 'Payment status',
  transactionStatus: 'Payment status',
  transactionNumber: 'Transaction number (order id)',
  period: 'Date range',
  reportName: 'Report name',
  role: 'Role',
  status: 'Status',
  to: 'To',
  notificationMethod: 'Notification method',
  orderId: 'Order ID',
  operationId: 'Operation ID',
  publicId: 'Public ID',
  sessionId: 'Session ID',
  orderIdApm: 'Order ID',
  clientIdCrypto: 'Customer ID',
  payoutType: 'Payout type',
  'payoutType.Single': 'All except bulk',
  'payoutType.All': 'All including bulk',
  'payoutType.Bulk': 'Bulk only',
  includeBulkPayouts: 'Include bulk payouts',
  cardLast4: 'Card number',
  userdata: 'User data',
  description: 'Additional data',
  rrn: 'RRN',
  cardLast4Placeholder: 'Last 4 digits of card',
  userdataPlaceholder: 'User data',
  descriptionPlaceholder: 'Additional data',
  rrnPlaceholder: 'RRN',
  sbpFilter: 'Fast Payment System',
  'sbpFilter.Sbp': 'SBP only',
  'sbpFilter.NonSbp': 'All except SBP',
  fasterPayoutSource: 'Payout method',
  'fasterPayoutSource.any': 'All methods',
  'fasterPayoutSource.Any': 'All methods',
  'fasterPayoutSource.api': 'API',
  'fasterPayoutSource.mc': 'Personal account',
  periodMaxLengthError: 'The period cannot exceed 1 month',
} as const;

export type TFieldsKeys = keyof typeof fieldsEn;

export const fieldsRu = {
  amount: 'Сумма',
  contract: 'Контракт',
  currency: 'Валюта',
  dateFrom: 'Период от',
  dateTo: 'Период до',
  from: 'От',
  paymentIndicator: 'Признак платежа',
  paymentMethod: 'Способ оплаты',
  paymentStatus: 'Статус платежа',
  transactionStatus: 'Статус платежа',
  transactionNumber: 'Номер транзакции (order id)',
  period: 'Период',
  reportName: 'Название отчета',
  role: 'Роль',
  status: 'Статус',
  to: 'До',
  notificationMethod: 'Способ уведомления',
  orderId: 'ID заказа',
  operationId: 'ID операции',
  publicId: 'Публичный идентификатор',
  sessionId: 'Идентификатор сессии',
  orderIdApm: 'Номер транзакции (order id)',
  clientIdCrypto: 'Идентификатор клиента',
  payoutType: 'Тип выплат',
  'payoutType.Single': 'Все, кроме массовых',
  'payoutType.All': 'Все, включая массовые',
  'payoutType.Bulk': 'Только массовые',
  cardLast4: 'Номер карты',
  userdata: 'Пользовательские данные',
  description: 'Дополнительные данные',
  includeBulkPayouts: 'Включать массовые операции',
  rrn: 'RRN',
  cardLast4Placeholder: 'Последние 4 цифры карты',
  userdataPlaceholder: 'Пользовательские данные',
  descriptionPlaceholder: 'Дополнительные данные',
  rrnPlaceholder: 'RRN',
  sbpFilter: 'Система быстрых платежей',
  'sbpFilter.Sbp': 'Только СБП',
  'sbpFilter.NonSbp': 'Все, кроме СБП',
  fasterPayoutSource: 'Способ выплаты',
  'fasterPayoutSource.any': 'Все способы',
  'fasterPayoutSource.Any': 'Все способы',
  'fasterPayoutSource.api': 'API',
  'fasterPayoutSource.mc': 'Личный кабинет',
  periodMaxLengthError: 'Период не может превышать 1 месяц',
} satisfies Record<TFieldsKeys, string>;
